/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AmountOrPercentage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Fixed from './Fixed/index'
import No from './No/index'
import Percentage from './Percentage/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AmountOrPercentage({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPayments/Content/Content/MinimumDownpaymentAmount/AmountOrPercentage"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let settingsDataMinimumDownpaymentTypeValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.minimum_downpayment.type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: settingsDataMinimumDownpaymentTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Percentage'}>
<Percentage
  viewPath={`${viewPath}/Percentage`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Fixed'}>
<Fixed
  viewPath={`${viewPath}/Fixed`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}